/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AvailableClassStudentViewModel } from "../types/AvailableClassStudentViewModel.ts";

export const availableClassStudentViewModelSchema = z.object({
  classStudentId: z.optional(z.number().int()),
  code: z.string().nullish(),
  description: z.string().nullish(),
  label: z.string().nullish(),
}) as unknown as ToZod<AvailableClassStudentViewModel>;
